export default "__VITE_ASSET__CH2Ugm2a__"